import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {LoadingService} from 'src/app/shared/service/loading.service';
import {ConfirmationDialogVccData} from 'src/app/virtual-credit-card/model/confirmation-dialog-vcc-data';
import {PaymentGatewayService} from 'src/app/virtual-credit-card/service/payment-gateway-service';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
    selector: 'app-confirmation-dialog-delete-vcc',
    templateUrl: './confirmation-dialog-delete-vcc.component.html',
    standalone: false
})
export class ConfirmationDialogDeleteVccComponent implements OnInit {
  isLoadingSpinner: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogDeleteVccComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogVccData,
    private paymentGatewayService: PaymentGatewayService,
    private _snackBar: MatSnackBar,
    public loader: LoadingService
  ) {
  }
  ngOnInit(): void {
    this.loader.hide();
    
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  okClick(): void {
    this.isLoadingSpinner = true;
    this.paymentGatewayService.deleteDbov2PaymentGatewayVccService(this.data)
    .subscribe({
      next: (_) => {
        this.isLoadingSpinner = false;
        this.dialogRef.close(true);
        this._snackBar.open(`Successfully virtual credit card is deleted for the service ID:'${this.data.adxBookingId}'.`, 'Dismiss', {
          duration: 0,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: ['message-position', 'app-notification-success']
        });
      },
      error: () => {
        this.isLoadingSpinner = false;
        this.dialogRef.close(false);
      }
    });
  }
}